import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const RearrangeListsHome = () => {
  const navigate = useNavigate();

  const cards = [
    {
      key: "City",
      title: "Rearrange City",
      description: "Rearrange Cities",
      image: "../images/Re-City.png",
      color: "#51E8FF",
      onClick: () => navigate("/rearrange-city-lists"),
    },
    {
      key: "POI",
      title: "Rearrange POI",
      description: "Rearrange Points of Interest",
      image: "../images/Re-POI.png",
      color: "#E3E2E2",
      onClick: () => navigate("/rearrange-poi-lists", { state: "0" }),
    },
    {
      key: "TripPOI",
      title: "Rearrange TripPOI",
      description: "Rearrange Trip POIs",
      image: "../images/Re-TripPOI.png",
      color: "#7CF578",
      onClick: () => navigate("/rearrange-trippoi-lists", { state: { status: "1" } }),
    },
  ];

  return (
    <div>
      <Title level={3} style={{ marginBottom: 24, color: '#41787C' }}>
        Rearrange Lists
      </Title>

      <Row gutter={[20, 20]}>
        {cards.map((card) => (
          <Col xs={24} sm={12} md={8} lg={6} key={card.key}>
            <Card
              hoverable
              onClick={card.onClick}
              cover={
                <div style={{ height: 180, borderRadius: 8, overflow: "hidden", position: "relative" }}>
                  <img
                    src={card.image}
                    alt={card.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      padding: 12,
                      background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                      color: "#fff",
                    }}
                  >
                    <Title level={4} style={{ margin: 0, color: card.color || "#fff", fontWeight: 600 }}>
                      {card.title}
                    </Title>
                    {card.description && <Text style={{ color: "#ddd", fontSize: 13 }}>{card.description}</Text>}
                  </div>
                </div>
              }
              style={{ borderRadius: 12, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              bodyStyle={{ padding: 0 }}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default RearrangeListsHome;
